import React from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {toast, ToastContainer} from 'react-toastify';
import {withStyles} from '@material-ui/core/styles';
import {ConfirmSignUp} from "aws-amplify-react";
import {I18n} from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';

import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import AmplifyTheme from '../../themes/AmplifyTheme';
import CssBaseline from '@material-ui/core/CssBaseline';

import Logo from "../../assets/img/logo-square-on-white.svg";

class CustomConfirmSignUp extends ConfirmSignUp
{
    constructor(props)
    {
        super(props);
        this._validAuthStates = ['confirmSignUp'];
        this.confirm = this.confirm.bind(this);
        this.resend = this.resend.bind(this);
    }

    confirm(e)
    {
        e.preventDefault();
        const username = this.usernameFromAuthData() || this.inputs.username.toLowerCase();
        const {code} = this.inputs;
        if (!Auth || typeof Auth.confirmSignUp !== 'function')
        {
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }

        Auth.confirmSignUp(username, code)
            .then(() => this.changeState('signedUp'))
            .catch((err) =>
            {
                switch (err.code)
                {
                    case 'CodeMismatchException':
                        toast.error("Der Bestätigungscode ist ungültig. Bitte versuchen Sie es erneut oder fordern Sie einen neuen Bestätigungscode an.")
                        break;
                    default:
                        toast.error("Es ist ein unbekannter Fehler aufgetreten. Bitte kontaktieren Sie den Support.")
                        break;
                }
            });
    }

    resend()
    {
        const username = this.usernameFromAuthData() || this.inputs.username.toLowerCase();
        if (!Auth || typeof Auth.resendSignUp !== 'function')
        {
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }

        Auth.resendSignUp(username);
    }

    showComponent()
    {
        const {classes} = this.props;
        const username = this.usernameFromAuthData();

        return (
            <MuiThemeProvider theme={AmplifyTheme}>
                <CssBaseline/>
                <div className={classes.main}>
                    <ToastContainer/>
                    <Paper className={classes.paper}>
                        <img src={Logo} width="200" height="200" alt="QRsticker logo"/>
                        <Typography component="h1" variant="h5" className={classes.title}>
                            {I18n.get('Registrierung abschließen')}
                        </Typography>
                        <hr/>
                        <Typography variant="caption">
                            Wir haben Ihnen einen Bestätigungscode per E-Mail geschickt. Bitte schauen Sie in Ihrem E-Mail Postfach nach.
                        </Typography>
                        <form className={classes.form} onSubmit={this.confirm}>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="username">{I18n.get('Username')}</InputLabel>
                                <Input id="username" key="username" name="username" autoComplete="username" autoFocus onChange={this.handleInputChange}
                                       disabled={(username !== null)} value={username ? username : ""}/>
                            </FormControl>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="code">{I18n.get('Bestätigungscode')}</InputLabel>
                                <Input id="code" key="code" name="code" autoComplete="code" autoFocus onChange={this.handleInputChange}/>
                            </FormControl>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="secondary"
                                className={classes.submit}>
                                {I18n.get('Confirm')}
                            </Button>
                            <Button
                                type="button"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={this.resend}>
                                {I18n.get('Neuen Code anfordern')}
                            </Button>
                            <hr/>
                            <Button
                                type="button"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={() => this.changeState('signIn')}>
                                {I18n.get('Back to Sign In')}
                            </Button>
                        </form>
                    </Paper>
                </div>
            </MuiThemeProvider>
        );
    }
}

export default withStyles(AmplifyTheme)(CustomConfirmSignUp);
